import { render, staticRenderFns } from "./teamsIndex.vue?vue&type=template&id=6524c0de&"
import script from "./teamsIndex.vue?vue&type=script&lang=js&"
export * from "./teamsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports